import { useAtom } from "jotai";
import { visibleDrawerCargarAtom } from "../DescansoMedicoStore";

const useDrawerCargarHistorico = () => {
  const [visible, setVisible] = useAtom(visibleDrawerCargarAtom);

  const mostrar = () => setVisible(true);
  const ocultar = () => setVisible(false);

  return { visible, mostrar, ocultar };
};

export default useDrawerCargarHistorico;
